/*
 * Mängdrabattstege.
 *
 * Markerar den nivå kunden ligger på utifrån antalet i antalsväljaren, och
 * låter kunden hoppa till en nivå genom att klicka på den.
 *
 * Rabatten i sig räknas av Shopify i kassan via en automatisk rabatt. Den här
 * filen räknar inga priser — den speglar bara vad kunden valt.
 */

class SsVolumeTiers extends HTMLElement {
  connectedCallback() {
    this.tiers = Array.from(this.querySelectorAll('[data-ss-tier]'));
    if (this.tiers.length === 0) return;

    this.quantityInput = document
      .querySelector('product-info')
      ?.querySelector('.quantity__input, input[name="quantity"]');

    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-ss-tier-select]');
      if (!trigger) return;
      this.setQuantity(parseInt(trigger.dataset.ssTierSelect, 10));
    });

    this.quantityInput?.addEventListener('change', () => this.highlight());
    this.quantityInput?.addEventListener('input', () => this.highlight());

    this.highlight();
  }

  setQuantity(qty) {
    if (!this.quantityInput || !qty) return;
    this.quantityInput.value = qty;
    // Dawn lyssnar på change för att uppdatera pris och lagerregler.
    this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    this.highlight();
  }

  highlight() {
    const current = parseInt(this.quantityInput?.value, 10) || 1;

    // Aktiv nivå är den högsta vars tröskel kunden nått.
    let active = null;
    for (const tier of this.tiers) {
      const qty = parseInt(tier.dataset.qty, 10);
      if (current >= qty) active = tier;
    }

    this.tiers.forEach((tier) => {
      const isActive = tier === active;
      tier.classList.toggle('ss-tier--active', isActive);
      tier.querySelector('[data-ss-tier-select]')?.setAttribute('aria-pressed', String(isActive));
    });
  }
}

if (!customElements.get('ss-volume-tiers')) {
  customElements.define('ss-volume-tiers', SsVolumeTiers);
}
